"use client";
import Image from 'next/image';

interface CloudflareStreamBackgroundProps {
  videoId: string;
  customerSubdomain: string;
  posterSrc?: string;
  className?: string;
}

const CloudflareStreamBackground = ({ 
  videoId, 
  customerSubdomain,
  posterSrc, 
  className = "" 
}: CloudflareStreamBackgroundProps) => {
  const iframeSrc = `https://${customerSubdomain}.cloudflarestream.com/${videoId}/iframe?autoplay=true&loop=true&muted=true&controls=false&preload=auto`;

  return (
    <div className={`absolute inset-0 w-full h-full pointer-events-none z-0 overflow-hidden ${className}`}>
      <iframe
        title="Revoyager Travel Video Background"
        src={iframeSrc}
        allow="autoplay; fullscreen; picture-in-picture"
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
        style={{
          width: "177.77vh", // 16:9 aspect ratio width
          height: "56.25vw", // 16:9 aspect ratio height
          minWidth: "100%",
          minHeight: "100%",
          border: "none",
        }}
      />
      
      {/* Fallback background image */}
      <noscript>
        <div style={{ width: '100%', height: '100%', background: '#191919', position: 'absolute', top: 0, left: 0, zIndex: 0 }}>
          {posterSrc && (
            <Image
              src={posterSrc}
              alt="Travel background"
              fill
              className="object-cover"
              sizes="100vw"
              priority
            />
          )}
        </div>
      </noscript>
      
      {/* Overlay for text readability */}
      <div className="absolute inset-0 bg-black/30"></div>
    </div>
  );
};

export default CloudflareStreamBackground;

